"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Form = _interopRequireDefault(require("react-bootstrap/Form"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * Form Inline is an inline-type form that enforces a special layout on
 * form controls within the form. The underlying implementation is a
 * react-bootstrap Form component, and all props are passed to the
 * react-bootstrap API.
 *
 * Management of state and selected items in form children is the responsibility
 * of the library consumer. The Blueprint-React library does not manage the
 * state of form components.
 */
const FormInline = allProps => {
  const {
    children,
    className = '',
    ...props
  } = allProps;
  const classElem = document.createElement('div');
  classElem.className = className;
  classElem.classList.add('mm-form-inline');
  return /*#__PURE__*/_react.default.createElement(_Form.default, _extends({
    className: classElem.classList.value
  }, props), children);
};
var _default = exports.default = FormInline;